import {
  DisabledButton,
  getTextInputProps,
  InputItem,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import {
  Team,
  useOrganization,
  useTeam,
} from '@foxtrotplatform/platform-micro-site-core';
import { Select } from '@windmill/react-ui';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { getOrgDeveloperTeams } from '../../common/api/organization';
import { requestToJoin } from '../../common/api/team';
import { addToast } from '../../common/reducers/toasterSlice';

interface SelectTeamForm {
  id: string;
}

export const SelectTeam: React.FunctionComponent = (): JSX.Element => {
  const { currentOrg } = useOrganization();
  const { teams } = useTeam();
  const dispatch = useDispatch();
  const [orgTeams, setOrgTeams] = useState<Team[]>();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<SelectTeamForm>({
    mode: 'onChange',
    defaultValues: {
      id: '',
    },
  });

  useEffect(() => {
    const getOrgTeams = async () => {
      const currentTeams = await getOrgDeveloperTeams(currentOrg?.id as string);

      if (currentTeams) {
        const teamsNotAssociatedToUser = currentTeams.filter(
          ({ id }) => !teams?.find((team) => team.id === id)
        );
        if (teamsNotAssociatedToUser && teamsNotAssociatedToUser.length > 0) {
          reset({ id: teamsNotAssociatedToUser[0].id });
          setOrgTeams(teamsNotAssociatedToUser);
        } else {
          setOrgTeams(undefined);
        }
      }
    };
    if (currentOrg) {
      getOrgTeams();
    }
  }, [currentOrg, teams]);

  const onSubmit = async (form: SelectTeamForm) => {
    const teamName = orgTeams?.find(({ id }) => id === form.id)?.name;
    try {
      await requestToJoin(currentOrg?.id as string, form.id as string);
      const newToastState = {
        message: `requested access to team: ${teamName}`,
        isError: false,
      } as ToasterState;
      dispatch(addToast(newToastState));
      reset();
    } catch {
      const newToastState = {
        message: `there was an error requesting access to  team: ${teamName}`,
        isError: true,
      } as ToasterState;
      dispatch(addToast(newToastState));
      reset();
    }
  };
  return (
    <form className="pb-os1-spacing w-full" onSubmit={handleSubmit(onSubmit)}>
      <PageTitle className="mb-os1-spacing">Select a Team</PageTitle>
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-col">
          <div className="flex flex-row items-center gap-x-3">
            <div>
              <InputItem title="Current Teams in Organization">
                <Select
                  css=""
                  defaultValue={orgTeams ? orgTeams[0].id : ''}
                  {...getTextInputProps({
                    inputKey: 'id',
                    errors,
                    register,
                    className: 'shadow-md',
                  })}
                >
                  {orgTeams ? (
                    orgTeams.map((team) => {
                      return (
                        <option key={`${team.id}`} value={team.id}>
                          {team.name}
                        </option>
                      );
                    })
                  ) : (
                    <option key="No team to choose" value="">
                      You are already a part of all teams within the org
                    </option>
                  )}
                </Select>
              </InputItem>
            </div>
            <div>
              <DisabledButton
                className="h-10 mt-1 rounded-md w-40"
                isActive={orgTeams !== undefined}
              >
                Request To Join
              </DisabledButton>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};
